/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Foxit_FilesInputs */

const en_pc_alt_t_foxit_files = /** @type {(inputs: Pc_Alt_T_Foxit_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On your device, plus Foxit cloud features if you use them`)
};

const zh_pc_alt_t_foxit_files = /** @type {(inputs: Pc_Alt_T_Foxit_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在你的设备上；如使用 Foxit 云功能则涉及云端`)
};

/**
* | output |
* | --- |
* | "On your device, plus Foxit cloud features if you use them" |
*
* @param {Pc_Alt_T_Foxit_FilesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_foxit_files = /** @type {((inputs?: Pc_Alt_T_Foxit_FilesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Foxit_FilesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_foxit_files(inputs)
	return zh_pc_alt_t_foxit_files(inputs)
});
export { pc_alt_t_foxit_files as "pc.alt.t.foxit.files" }